// Copyright 2023, Durable
import React, { useEffect } from "react";

/**
 * A page header, which all pages should include. Auto-set for developer tools.
 * This page header will display or not based on setting, but will always
 * handle accessibility and set the page title itself.
 */
function PageHeader({
  visible = true,
  title,
  description,
  icon
}: {
  visible?: boolean;
  title: string;
  description: string;
  icon?: JSX.Element;
}) {
  useEffect(() => {
    document.title = `${title} - Durable`;
  }, [title]);

  return (
    <div
      className={`page-header pb-5 ${!visible ? "sr-only" : "not-sr-only"}`}
    >
      <div className="flex">
        {icon != null && (
          <div className="text-4xl mr-3 dark:text-coolGrey-900">{icon}</div>
        )}
        <h1
          className={`m-0 text-4xl font-normal text-coolGrey-100
      dark:text-coolGrey-1000`}
        >
          {title}
        </h1>
      </div>
      <h2
        className={`m-0 mt-1 text-xl font-normal text-coolGrey-500
        dark:text-coolGrey-800`}
      >
        {description}
      </h2>
    </div>
  );
}

export { PageHeader };
